import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';


import DataTable from './datatable';

import PageSubHeader from '../../pagesubheader'
import ContainerHeader from '../../../components/ContainerHeader/index';
import * as archivedetails from '../../../actions/archivedetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

class MeetingList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            setValue: false, committee_id: Number(this.props.params.id ? this.props.params.id : this.props.loginUser.data.committee_id),
            filterText: '',
        }
    }
    handleChangeTeam(e) {
        this.setState({ setValue: false, committee_id: Number(e.target.value) })
        this.props.actions.getArchiveDetailsList(e.target.value);
        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    componentDidMount() {
        // console.log('props', this.props)
        this.setState({ setValue: false, })
        this.props.actions.loadswitchercommittees();
        if (this.state.committee_id > 0)
            this.props.actions.getArchiveDetailsList(this.state.committee_id);
    }

    handleUserInput(filterText) {
        this.setState({ filterText: filterText });
    };
    render() {
        const { getDataList, teamDetails, match } = this.props;
        let archivedetailsList = null
        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('getDataList', getDataList);
        if ((getDataList && getDataList.Status) || (teamDetails && teamDetails.Status)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (getDataList && getDataList.archivedetailsList && getDataList.archivedetailsList.length > 0 && !this.state.setValue) {
            archivedetailsList = getDataList.archivedetailsList;
            this.setState({ setValue: true })
        }
        let _TeamList = null
        // console.log('AddRole TeamList', roleList)
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
        }

        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="Archive Meeting List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <PageSubHeader committee_id={this.state.committee_id} handleChangeTeam={this.handleChangeTeam.bind(this)}
                            teamDetails={teamDetails}
                            onUserInput={this.handleUserInput.bind(this)} />
                        <div className="row">
                            <div className="col-12">
                                <DataTable data={getDataList && getDataList.archivedetailsList ? getDataList.archivedetailsList : null}
                                    filterText={this.state.filterText} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { loginUser, archiveDetails, teamDetails } = state
    const { match } = ownProps
    return { loginUser, getDataList: archiveDetails, teamDetails, params: ownProps.match.params, match }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, archivedetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MeetingList);



// WEBPACK FOOTER //
// ./app/archivedetails/meetinglist/index.js